import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import { groupStyle } from './chip-group.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


@customElement('cse-chip-group')
export class CSEChipGroup extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, groupStyle]

  @property({ type: Boolean })
  wrap = false

  @property({ type: Boolean })
  scrollable = false

  @property({ type: String, attribute: 'align' })
  align: 'left' | 'right' = 'left'

  override render() {
    return html`
      <div class="${classMap({
        'cse-chip-group': true,
        'wrap': this.wrap,
        'scroll': this.scrollable,
        'align-right': this.align === 'right'
      })}">
        <slot></slot>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-chip-group': CSEChipGroup
  }
}
